import React from 'react';
import { useSelector } from 'react-redux';
import { Switch } from 'react-router-dom';
import { Route } from '@modernhealth/web-analytics';
import { useFlags } from 'launchdarkly-react-client-sdk';

import Landing from 'src/pages/Landing';
import Login from 'src/pages/Login';
import SsoLogin from 'src/pages/SsoLogin';
import { getCurrentUser } from 'src/selectors/userSelectors';

import { getRoutes } from './applicationRoutes';

export const Routes: React.FC = () => {
  const currentUser = useSelector(getCurrentUser);
  const { invoicingDashboard } = useFlags();

  const routes = getRoutes(currentUser.providerInvoicingOnly && invoicingDashboard);

  return (
    <Switch>
      <Route
        exact
        path="/"
        analytics={{
          pageName: 'landing',
        }}
        render={(props) => (
          <Landing
            {...props}
            defaultAuthenticatedRoute={
              currentUser.providerInvoicingOnly ? '/invoicing' : '/sessions'
            }
          />
        )}
      />
      <Route
        exact
        path="/sso-login"
        component={SsoLogin}
        analytics={{
          pageName: 'sso-login',
        }}
      />
      <Route
        exact
        path="/login"
        analytics={{
          pageName: 'login',
        }}
        render={(props) => <Login {...props} />}
      />

      {routes}

      <Route
        analytics={{
          pageName: 'not-found',
        }}
        render={() => <div> Sorry, this page does not exist. </div>}
      />
    </Switch>
  );
};
